import { Card, type CardProps } from '@/components/ui/card'
import { cn } from '@/lib/utils'

export function OrderAsidePanelCard({ className, ...props }: CardProps) {
  return <Card surface="bare" className={cn(className)} {...props} />
}
